import type { SheetSelectionType } from '../../types/stockImports.types'

export type ExcelCellValue = string | number | boolean | null

export interface ParsedRow {
  rowNumber: number
  cells: ExcelCellValue[]
}

export interface ParsedSheet {
  name: string
  index: number
  maxColumns: number
  rows: ParsedRow[]
}

export const columnRoles = [
  { value: 'articleColumnNumber', label: 'Артикул (производителя)' },
  { value: 'articleInchColumnNumber', label: 'Артикул (поставщика)' },
  { value: 'barcodeColumnNumber', label: 'Штрихкод' },
  { value: 'descriptionColumnNumber', label: 'Наименование' },
  { value: 'brandColumnNumber', label: 'Бренд' },
  { value: 'quantityColumnNumber', label: 'Остаток' },
] as const

export const priceColumnRoles = [
  { value: 'purchaseColumnNumber', label: 'Закупочная цена' },
  { value: 'rrcColumnNumber', label: 'РРЦ' },
  { value: 'currencyColumnNumber', label: 'Валюта' },
] as const

export type PriceColumnRole = (typeof priceColumnRoles)[number]['value']

export const priceColumnRolesWithoutCurrency = priceColumnRoles.filter(
  (role) => role.value !== 'currencyColumnNumber'
)

export type ColumnRole = (typeof columnRoles)[number]['value'] | PriceColumnRole

export type ColumnRoleOption = { value: ColumnRole; label: string }

export interface ExcelMapperValues extends Partial<Record<ColumnRole, number>> {
  startRowIndex?: number
  endRowIndex?: number
  sheetSelectionType?: SheetSelectionType
  sheetNames?: string
  sheetIndexes?: string
}

export const getExcelColumnName = (index: number) => {
  let value = index + 1
  let name = ''

  while (value > 0) {
    const remainder = (value - 1) % 26
    name = String.fromCharCode(65 + remainder) + name
    value = Math.floor((value - 1) / 26)
  }

  return name
}
